/* Compare: sticky bar. Names come from window.croCompareData, printed by
   Liquid, so the bar needs no fetch and cannot show a stale title.
   The Compare control is an anchor, so it is muted with a class and
   aria-disabled rather than the disabled property, which anchors ignore. */
(function () {
  var bar;
  function draw() {
    if (!bar) return;
    var list = window.croCompare.read();
    var d = window.croCompareData || {};
    if (!list.length) { bar.hidden = true; return; }
    bar.querySelector('[data-cmp-chips]').innerHTML = list.map(function (h) {
      var t = (d[h] && d[h].title) || h;
      return '<button type="button" class="cro-cmp__chip" data-compare="' + h +
        '" aria-label="Remove ' + t + '">' + t + '<span aria-hidden="true">x</span></button>';
    }).join('');
    bar.querySelector('[data-cmp-count]').textContent = list.length;
    var go = bar.querySelector('[data-cmp-go]');
    var ok = list.length > 1;
    go.classList.toggle('is-off', !ok);
    go.setAttribute('aria-disabled', ok ? 'false' : 'true');
    bar.hidden = false;
  }
  function init() {
    bar = document.querySelector('[data-cmp-bar]');
    if (!bar) return;
    bar.querySelector('[data-cmp-clear]').addEventListener('click', function () {
      window.croCompare.clear();
    });
    bar.querySelector('[data-cmp-go]').addEventListener('click', function (e) {
      if (this.getAttribute('aria-disabled') === 'true') e.preventDefault();
    });
    document.addEventListener('compare:changed', draw);
    draw();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
